import React from "react";
import PromptSubmitter from "./PromptSubmitter";
import Messages from "./Messages";
import {
  useGptHistoryStore,
  useUbiApiChatCompletion,
  useUbiVision,
} from "../../../api/calls/OpenAi";
import {
  useScreenshotRectangleStore,
  useWidePopupStore,
} from "../../../api/Zustand";

import { RootState } from "@react-three/fiber";

export async function generateImage(
  webglRoot: RootState,
  w?: number
): Promise<string> {
  const canvas = document.createElement("canvas");
  const pos = useScreenshotRectangleStore.getState().position;

  // const width = w ?? 500;
  canvas.width = pos.w;
  canvas.height = pos.h;
  const ctx = canvas.getContext("2d");

  const blob = webglRoot.gl.domElement.toDataURL();

  const img = new Image();
  img.src = blob;

  return new Promise((resolve) => {
    img.onload = () => {
      const { naturalWidth, naturalHeight } = img;

      // ctx?.drawImage(
      //   img,
      //   naturalWidth / 2 - 250,
      //   naturalHeight / 2 - 250,

      //   naturalWidth,
      //   naturalHeight,
      //   0,
      //   0,
      //   naturalWidth,
      //   naturalHeight
      // );

      // canvas.width = img.naturalWidth;

      // canvas.height = img.naturalHeight;

      // ctx?.drawImage(img, 0, 0);

      ctx?.drawImage(img, -pos.x, -pos.y);

      const imgUrl = canvas.toDataURL("img/jpg");
      //

      resolve(imgUrl);
      ctx?.reset();
    };
  });
}

export type message = {
  role: string;
  content: string;
  loading?: boolean;
  error?: Error;
  image?: string;
};

const OpenAiWrapper = (props: { tourID: number }) => {
  const { mutateAsync, isPending, error } = useUbiApiChatCompletion();
  const { mutateAsync: visionMutateAsync, isPending: isVisionPending } =
    useUbiVision();

  const { resetHistory } = useGptHistoryStore();

  const { visionIsloading } = useWidePopupStore();

  const isLoading = isPending || visionIsloading || isVisionPending;

  return (
    <div style={WrapperStyle} className="openai-wrapper">
      <Messages isPending={isLoading} tourID={props.tourID} />

      <div style={{ display: "flex" }}>
        <button
          type="button"
          id="gpt-reset"
          title="Resetta la conversazione"
          onClick={() => resetHistory()}
        >
          {reset}
        </button>
      </div>
      <PromptSubmitter
        mutateAsync={mutateAsync}
        isPending={isLoading}
        visionMutateAsync={visionMutateAsync}
      />
      {/* <button onClick={() => resetHistory()}>Reset</button> */}
    </div>
  );
};

export default OpenAiWrapper;

const WrapperStyle: React.CSSProperties = {
  flex: 1,
  // paddingTop: 50,
  paddingBottom: 20,
  paddingRight: 100,
  paddingLeft: 100,
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
};

const reset = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24"
    viewBox="0 -960 960 960"
    width="24"
  >
    <path d="M451-122q-123-10-207-101t-84-216q0-77 35.5-145T295-695l43 43q-56 33-87 90.5T220-439q0 100 66 173t165 84v60Zm60 0v-60q100-12 165-84.5T741-439q0-109-75.5-184.5T481-699h-20l60 60-43 43-133-133 133-133 43 43-60 60h20q134 0 227 93.5T801-439q0 125-83.5 216T511-122Z" />
  </svg>
);
